import api from '../utils/api'
import { type BreadcrumbT } from '../components/CustomBreadcrumbs'
import { type SurveyCompletionRate } from '../models/Division'
import { type AxiosResponse } from 'axios'

interface ParamsType {
  termId: string | null
  distributionSeriesId: string | null
  pageSize: number
}
export const getBreadCrumbList = async (urlId: string): Promise<BreadcrumbT[]> => {
  const response = await api.get(`/api/divisions/path/${urlId}`)
  return response.data
}

export const getCompletionRate = async (divisionId: string, params?: ParamsType): Promise<SurveyCompletionRate> => {
  const response = await api.get(`/api/divisions/${divisionId}/completion_rates/`, { params })
  return response.data
}

// Export division reports as CSV
export const getDivisionCSVExport = async (divisionId: string, params?: ParamsType): Promise<Blob> => {
  const response = await api.get(`/api/divisions/${divisionId}/reports/export/csv/`, { params, responseType: 'blob' })
  return response.data
}
// Export division reports as PDF
export const getDivisionPDFExport = async (divisionId: string, params?: ParamsType): Promise<Blob> => {
  const response = await api.get(`/api/divisions/${divisionId}/reports/export/pdf/`, { params, responseType: 'blob' })
  return response.data
}

export const getSectionTable = async (divisionId: string, categoryName: string, params: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/divisions/${divisionId}/completion_rates/children/${categoryName}/`, {
    headers: { Accept: 'application/cdg' },
    params
  })
}

interface getReportsV2Params {
  divisionId: string
  params: ParamsType
  data: any
}

export const getReportsV2 = async ({ divisionId, params, data }: getReportsV2Params): Promise<AxiosResponse> => {
  const response = await api.post(`/api/divisions/${divisionId}/reports/v2/?term_id=${params.termId}&distribution_series_id=${params.distributionSeriesId}`, data)
  return response.data
}

interface getReportsCompareParams {
  params: ParamsType
  divisionId: string
  data: {
    calculations?: string[]
    compareIds?: string[]
    limit?: number
  }
}

export const getCategoryTabsChildren = async (categoryName: string): Promise<any> => {
  const response = await api.get(`/api/acad_units/category_name/${categoryName}/children/`)
  return response.data
}

export const getReportsCompare = async ({ params, divisionId, data }: getReportsCompareParams): Promise<AxiosResponse> => {
  const response = await api.post(`/api/divisions/${divisionId}/reports/compare/`, data, { params })
  return response.data
}

export const getHistoricalTrendsReports = async ({ params, divisionId, data }: getReportsCompareParams): Promise<AxiosResponse> => {
  const response = await api.post(`/api/divisions/${divisionId}/reports/history/`, data, { params })
  return response.data
}

const exportCourseCatalogCSV = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/divisions/export/', { params })
}

export default {
  getBreadCrumbList,
  getCompletionRate,
  getDivisionPDFExport,
  getDivisionCSVExport,
  getSectionTable,
  getCategoryTabsChildren,
  getReportsV2,
  getReportsCompare,
  getHistoricalTrendsReports,
  exportCourseCatalogCSV
}
